/**
 * LanguageSwitcher.jsx — Sélecteur de langue FR / EN (Vague 0 : infrastructure)
 *
 * Composant PUR : il rend toujours les deux boutons. Le GATING (affichage en
 * dev seulement, masqué en prod) est fait au site de montage dans App.jsx via
 * le flag REACT_APP_I18N_SWITCHER — pas ici — pour rester directement testable.
 *
 * Libellés 'FR' / 'EN' INVARIANTS (non traduits, jamais passés par t()) :
 * un sélecteur de langue doit rester lisible quelle que soit la langue active.
 *
 * La persistance du choix est gérée par i18next-browser-languagedetector
 * (caches: ['localStorage'], clé 'ekynair_lang') — pas de localStorage manuel ici.
 */
import React from 'react';
import { useTranslation } from 'react-i18next';

const LANGS = [
  { code: 'fr', label: 'FR' },
  { code: 'en', label: 'EN' },
];

const LanguageSwitcher = ({ darkMode = false }) => {
  const { i18n } = useTranslation();
  const current = (i18n.resolvedLanguage || i18n.language || 'fr').slice(0, 2);

  return (
    <div role="group" aria-label="Choix de la langue"
      style={{ display: 'inline-flex', gap: '2px', alignItems: 'center' }}>
      {LANGS.map(({ code, label }) => {
        const active = current === code;
        return (
          <button
            key={code}
            type="button"
            onClick={() => i18n.changeLanguage(code)}
            aria-pressed={active}
            lang={code}
            style={{
              fontFamily: "'Inter', sans-serif",
              fontSize: '12px',
              fontWeight: '700',
              letterSpacing: '0.5px',
              padding: '4px 8px',
              borderRadius: '6px',
              cursor: 'pointer',
              border: '1px solid rgba(255,255,255,0.35)',
              background: active ? 'rgba(255,255,255,0.9)' : 'transparent',
              color: active ? (darkMode ? '#0D2A5C' : '#1B77F1') : '#fff',
              transition: 'background 0.2s, color 0.2s',
            }}
          >
            {label}
          </button>
        );
      })}
    </div>
  );
};

export default LanguageSwitcher;
